import { createFileIcon } from '../createFileIcon/createFileIcon';
import FileIconXlsSizeM from './FileIconXls_size_m';
import FileIconXlsSizeS from './FileIconXls_size_s';

export const FileIconXls = createFileIcon({
  m: FileIconXlsSizeM,
  s: FileIconXlsSizeS,
  name: 'FileIconXls',
});
